import { ValidationResponse } from '../../components/MainSettings/ValidationRule/types';
import { loginApi } from '../setup/setupApi';
import {
  EmailNotificationsResponse,
  LoginProjectConfiguration,
  LoginWidgetParamsType,
  MerchantProjectsResponse,
  PutFieldsValidateSettingsProps
} from './types';

export const getLoginConfigurations = (projectId: string): Promise<LoginProjectConfiguration> =>
  loginApi.get(`projects/${projectId}/fine_configuration`).then((res) => res.data);

export const putLoginConfigurations = (
  values: LoginProjectConfiguration
): Promise<LoginProjectConfiguration> =>
  loginApi.put(`projects/${values.id}/configuration`, values).then((res) => res.data);

export const patchFineConfigurations = (
  values: Partial<LoginProjectConfiguration>,
  projectId: string
): Promise<boolean> =>
  loginApi.patch(`projects/${projectId}/fine_configuration`, values).then(() => true);

export const getFieldsValidations = (projectId: string): Promise<ValidationResponse> =>
  loginApi.get(`projects/${projectId}/custom_validation`).then((res) => res.data);

export const putFieldsValidateSettings = async ({
  projectId,
  values
}: PutFieldsValidateSettingsProps): Promise<ValidationResponse> =>
  loginApi.put(`projects/${projectId}/custom_validation`, values).then((res) => res.data);

export const getEmailNotifications = (projectId: string): Promise<EmailNotificationsResponse> =>
  loginApi.get(`projects/${projectId}/email_notification`).then((res) => res.data);

export const deleteLoginProject = (projectId: string): Promise<boolean> =>
  loginApi.delete(`projects/${projectId}`).then(() => true);

export const getLoginWidgetParams = (): Promise<LoginWidgetParamsType> =>
  loginApi.get('widget/params').then((res) => res.data);

export const getMerchants = (merchantId: string | number): Promise<MerchantProjectsResponse> => {
  return loginApi
    .get(`https://api.xsolla.com/merchant/v3/merchants/${merchantId}/projects?sort=desc`)
    .then((res) => res.data);
};
